import type { InjectionKey } from "vue";

export interface CustomActionButtonHandler {
  handleCustomAction: (code: string) => void;
}

export const customActionButtonInjectKey: InjectionKey<CustomActionButtonHandler> =
  Symbol("customActionButton");
